/**
 * @namespace computec.b2b.portal.auth
 */

export function randomString(byteLen = 32): string {
	const arr = new Uint8Array(byteLen);
	crypto.getRandomValues(arr);
	return base64UrlEncode(arr);
}

export async function sha256(input: string): Promise<string> {
	const data = new TextEncoder().encode(input);
	const hash = await crypto.subtle.digest("SHA-256", data);
	return base64UrlEncode(new Uint8Array(hash));
}

function base64UrlEncode(bytes: Uint8Array): string {
	let str = "";
	for (let i = 0; i < bytes.byteLength; i++) {
		str += String.fromCharCode(bytes[i]);
	}
	return btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
